import './Icon_Headset.css';
import {ReactComponent as HeadsetIcon} from './Icons_Bot_Outline_Brand.svg';
function Icon_Headset() {
  return (
    <div className='icon-container-headset'>
      <HeadsetIcon className="headset-svg" />
    </div>
  );
}

export default Icon_Headset;

